export default "<div class=\"loadcss\" *ngIf=\"load\">\n    <img src=\"./../../../assets/img/load3.gif\" alt=\"Loading...\">\n</div> ";